import React, { useEffect, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import TextArea from 'Components/Textarea';
import config from 'Config/firebase';
import * as Regex from '../regex';
import ItemDetails from 'Components/ItemDetails';
import NumberFormat from 'react-number-format';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CheckIcon from '@material-ui/icons/Check';
import Loading from 'Components/Loading';
import history from '../history';

const pageStyles = (theme) => ({
  pageWrapper: {
    padding: '5%',
  },
  pageHeader: {
    marginBottom: '55px',
  },
  itemContainer: {
    marginTop: '40px',
  },
  textArea: {
    fontSize: 20,
  },
  contactButton: {
    marginTop: 70,
  },
  exitButtons: {
    marginTop: '40px',
  },
  submitButton: {
    marginTop: 40,
    marginLeft: 0,
  },
  itemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '90px',
  },
  itemName: {
    marginBottom: 20,
  },
  itemNameLink: {
    marginBottom: 20,
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  itemOverview: {
    marginBottom: 70,
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  itemMainInformation: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '50px',
    },
  },
  itemMessage: {
    marginBottom: 0,
  },
  contactHeader: {
    marginBottom: '15px',
  },
  phoneNumber: {
    fontSize: '14px',
    lineHeight: '14px',
    fontFamily: 'Roboto',
    letterSpacing: '0.5px',
  },
  itemImage: {
    maxHeight: '300px',
    maxWidth: '300px',
    cursor: 'pointer',
  },
  imageAndCodeContainer: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  successMessage: {
    marginTop: '50px',
  },
});

function Item({ classes, getItem, item, id, setActiveModal }) {
  const { register, handleSubmit, errors } = useForm();
  const [showContact, setShowContact] = useState(true);
  const [wasMailSent, setWasMailSent] = useState(false);
  if (item.claimed === false) {
    history.push(`/register/${item.itemId}`);
  }

  useEffect(() => {
    getItem(id);
  }, [getItem, id]);

  //console.log('item', item);
  //When there is no image
  const image = (item.images && item.images[0]) || '';

  const onSubmit = async (data) => {
    // There is some horrible bug where useEffect seems to wipe out the form values
    // This only happens with mui inputs
    // There might be a way to re-register the form elements inside the useEffect
    // But until someone figures that out this works
    const email = document.getElementsByName('email')[1].value;
    const phone = document.getElementsByName('phone')[1].value;
    const message = document.getElementsByName('message')[1].value;
    const _data = {
      email,
      message,
      phone,
      item,
      ownerId: item.ownerId,
    };

    if (item.phoneActive) {
      try {
        fetch(`${config.functionsURL}/sendText`, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(_data),
        });
      } catch (err) {
        console.warn('Contact text server error: ', err);
        alert('Sending text error');
        return;
      }
    }
    try {
      fetch(`${config.functionsURL}/contactOwner`, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(_data),
      });
    } catch (err) {
      console.warn('Contact server error: ', err);
      alert('Sending email error');
      return;
    }

    setWasMailSent(true);
  };

  if (item.loading) {
    return (
      <Loading
        type={'bubbles'}
        color={'#ccc'}
        height={'80px'}
        width={'80px'}
        containerHeight={'70vh'}
        containerWidth={'100%'}
        message={'Loading item...'}
      />
    );
  }

  if (!item.itemId) {
    return (
      <Page wrapperStyles={classes.pageWrapper}>
        <h2>
          Item ID not found. Please check your Item ID. It's CaSe sensitive.
        </h2>
        <p>
          <Button
            variant="contained"
            color="primary"
            className={classes.exitButtons}
            onClick={() => setActiveModal('foundItem')}
          >
            Enter a Code
          </Button>
        </p>
        <p>
          <Button
            component={Link}
            className={classes.exitButtons}
            to="/item-review"
            variant="contained"
            color="primary"
          >
            Make a tag!
          </Button>
        </p>
      </Page>
    );
  }

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      <div key={item.itemId} className={classes.itemContainer}>
        <ItemDetails
          name={item.name}
          itemId={item.itemId}
          message={item.message}
          phone={item.phone}
          imageUrl={image}
          secondaryHeaderContent={<></>}
          isQrVisible={false}
          additionalMainContent={
            <>
              {!showContact ? (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.contactButton}
                  onClick={() => setShowContact(true)}
                >
                  Contact Owner
                </Button>
              ) : (
                <>
                  {!wasMailSent && (
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className={classes.form}
                    >
                      <Typography
                        variant="body1"
                        className={classes.itemMessage}
                      >
                        Please fill out the form below to contact the owner.
                      </Typography>
                      <FormTextField
                        fullWidth
                        label="Email to Reach You"
                        name="email"
                        margin="normal"
                        required
                        error={!!errors.email}
                        helperText={errors.email && errors.email.message}
                        inputRef={register({
                          required: 'Provide your email',
                          pattern: {
                            value: Regex.email,
                            message: 'Provide a valid email address',
                          },
                        })}
                        placeholder="Enter Email"
                      />
                      <NumberFormat
                        customInput={FormTextField}
                        format="###-###-####"
                        mask="_"
                        fullWidth
                        label="Phone Number"
                        name="phone"
                        error={!!errors.phone}
                        helperText={errors.phone && errors.email.phone}
                        inputRef={register}
                        value=""
                        placeholder="Enter Phone Number"
                      />
                      <FormTextField
                        fullWidth
                        label="Message"
                        name="message"
                        required
                        error={!!errors.message}
                        helperText={
                          errors.message
                            ? errors.message.message
                            : 'Enter a message to send to the item owner'
                        }
                        inputRef={register({
                          required: 'Enter a message to send to the item owner',
                          minLength: {
                            value: 10,
                            message: 'Please leave a more detailed message',
                          },
                        })}
                        defaultValue="I found your item. Please contact me."
                        multiline
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submitButton}
                      >
                        Send
                      </Button>
                    </form>
                  )}

                  <Collapse in={wasMailSent}>
                    <Alert
                      icon={<CheckIcon fontSize="inherit" />}
                      severity="success"
                      onClose={() => setWasMailSent(false)}
                      className={classes.successMessage}
                    >
                      Your message has been sent. Thank you!
                    </Alert>
                  </Collapse>
                </>
              )}
            </>
          }
        />
      </div>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getItem: actions.getItem,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

function mapStateToProps({ item }, ownProps) {
  return {
    id: ownProps.match.params.id,
    item,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(Item)),
);
